import axios from "axios";
import store from "redux/Store";
import { mlUploadLibrary, pagingTotalRelation } from "redux/Types";
import { FilterOperatorTypes } from "util/table-view/TableTypes";
import { v4 as uuidv4 } from "uuid";
var module = "/uploadSessionContent/";
export const actionTypes = {
  LOADING: "LOADING" + module,
  LOAD: "LOAD" + module,
  ERROR: "ERROR" + module,
  FOCUS_ITEM: "FOCUS_ITEM" + module,
  SELECT_ITEMS: "SELECT_ITEMS" + module,
  QUERY: "QUERY" + module,
  EDIT_ITEM: "EDIT_ITEM" + module,
  POSTING: "POSTING" + module,
  POST_OK: "POSTOK" + module,
  POST_ERROR: "POST_ERROR" + module,
  SET_PLAYLIST: "SET_PLAYLIST" + module,
  UPDATE_QUEUE: "UPDATE_QUEUE" + module,
  LOADING_SESSION_TRACKS: "LOADING_SESSION_TRACKS" + module,
  LOAD_SESSION_TRACKS: "LOAD_SESSION_TRACKS" + module,
  ERROR_SESSION_TRACKS: "ERROR_SESSION_TRACKS" + module,
  ALBUM_EDITOR_OPEN: "ALBUM_EDITOR_OPEN" + module,
};

export const openAlbumEditor = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.ALBUM_EDITOR_OPEN,
    payload: item,
  });
};

export const saveItem =
  (message, libId, done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    dispatch({
      type: actionTypes.POSTING,
      payload: message,
    });
    axios
      .post(`${orgID}/uploads/session/save`, { libId })
      .then((res) => {
        dispatch({
          type: actionTypes.POST_OK,
          sessionId: res.data.id,
        });
        if (done) done(res.data, null);
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ERROR,
          payload: { e: err },
        });
      });
  };

export const updateSession =
  (done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    axios
      .post(`${orgID}/uploads/UpdateSession`)
      .then((res) => {
        if (done) done(res.data, null);
      })
      .catch((err) => {
        if (done) done(null, err.message || "error");
      });
  };

export const getTracksAndAlbumsFromSession = (sessionId) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  //query.orderBy = "date_last_edited"

  const tId = uuidv4();
  dispatch({
    type: actionTypes.LOADING_SESSION_TRACKS,
  });
  axios
    .post(
      `${orgID}/uploads/session/get_tracks_and_albums`,
      { sessionId },
      {
        headers: { tid: tId, orgid: orgID },
      }
    )
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.LOAD_SESSION_TRACKS,
          payload: res.data.results,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR_SESSION_TRACKS,
        payload: { e: err },
      });
    });
};

export const updateUploadQueue = (queue) => (dispatch) => {
  dispatch({
    type: actionTypes.UPDATE_QUEUE,
    payload: queue,
  });
};

export const getSessionById = (id) =>
  new Promise(function (resolve, reject) {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    axios
      .post(`${orgID}/plcontent/search`, {
        plid: id,
        order: "desc",
        orderBy: "updatedAt",
        page: 0,
        size: 10000,
      })
      .then((res) => {
        resolve(res?.data?.results ? res.data.results : []);
      })
      .catch((err) => {
        resolve([]);
      });
  });

export const addSessionItems =
  (action, message, items, done = null) =>
  (dispatch) => {
    dispatch({
      type: actionTypes.LOAD,
      payload: items,
    });
  };

export const postItem =
  (action, message, items, done = null) =>
  (dispatch) => {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();
    const tId = uuidv4();

    dispatch({
      type: actionTypes.POSTING,
      payload: message,
    });

    axios
      .post(`${orgID}/playlist/${action}`, items, {
        headers: { tid: tId, orgid: orgID },
      })
      .then((res) => {
        dispatch({
          type: actionTypes.POST_OK,
          payload: res.data,
        });

        if (done) done(res.data, null);
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.POST_ERROR,
          payload: { e: err },
        });

        if (done) done(null, err);
      });
  };

export const setQuery =
  (query, done = null) =>
  (dispatch) => {
    dispatch({
      type: actionTypes.QUERY,
      payload: query,
    });

    if (done) done();
  };

export const selectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_ITEMS,
    payload: items,
  });
};

export const focusItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.FOCUS_ITEM,
    payload: item,
  });
};

export const search = (query, libId) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
    mlTrackUpdateReducer: { uploadLibId },
  } = store.getState();

  const myqueryFilter = [...query.filters];

  if (uploadLibId != mlUploadLibrary.EMPTY) {
    myqueryFilter.push({
      operator: FilterOperatorTypes.equals,
      value: [uploadLibId],
      field: "library_id",
    });
  } else {
    myqueryFilter.push({
      operator: FilterOperatorTypes.empty,
      value: [],
      field: "library_id",
    });
  }

  const tId = uuidv4();
  dispatch({
    type: actionTypes.LOADING,
  });
  axios
    .post(
      `${orgID}/uploads/session/search`,
      { ...query, filters: myqueryFilter },
      {
        headers: { tid: tId, orgid: orgID },
      }
    )
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.LOAD,
          payload: res.data.results,
          total: res.data.total,
          totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err },
      });
    });
};
